<div class="history-panel">
  <nz-table
    #schedulerTable
    [nzData]="filteredRows"
    [nzNoResult]="noDataTemplate"
    [nzFrontPagination]="true"
    [nzPageSize]="10"
    [nzScroll]="{ x: '98.75rem', y: 'calc(100vh - 18rem)' }"
    nzSize="middle"
    nzBordered
  >
    <thead>
      <tr>
        <ng-container *ngFor="let header of headers; trackBy: trackByHeader">
          <th
            *ngIf="header.sortFn; else nonSortableHeader"
            [nzSortFn]="header.sortFn"
            [nzSortDirections]="header.sortDirections"
            [nzSortOrder]="header.sortOrder"
            [nzFilters]="header.filters"
            [nzFilterMultiple]="header.filterMultiple"
            [nzFilterFn]="header.filterFn"
            [nzWidth]="header.width"
            [nzRight]="header.right"
            [class.action-header]="header.name === 'Action'"
          >
            {{ header.name }}
          </th>
          <ng-template #nonSortableHeader>
            <th [nzWidth]="header.width" [nzRight]="header.right" [class.action-header]="header.name === 'Action'">
              {{ header.name }}
            </th>
          </ng-template>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of schedulerTable.data">
        <td nzEllipsis [nz-tooltip]="row.schedulerName">{{ row.schedulerName }}</td>
        <td nzEllipsis>{{ row.queryId }}</td>
        <td nzEllipsis [nz-tooltip]="row.queryName">{{ row.queryName }}</td>
        <td>
          <nz-tag [nzColor]="getStatusColor(row.status)">{{ getDisplayStatus(row.status) }}</nz-tag>
        </td>
        <td>{{ row.lastModifiedAt | dateTime }}</td>
        <td nzEllipsis [nz-tooltip]="row.lastModifiedBy">{{ row.lastModifiedBy }}</td>
        <td nzRight class="action-column">
          <div class="action-btns">
            <span
              [nz-tooltip]="row.queryType === 'STANDARD' ? templatedQueryEditTooltip : null"
              [attr.aria-label]="row.queryType === 'STANDARD' ? templatedQueryEditTooltip : null"
            >
              <button
                nz-button
                nzType="text"
                [disabled]="canEditScheduleHistory(row)"
                aria-label="Edit query"
                (click)="onEditClick(row)"
              >
                <span nz-icon nzType="edit" nzTheme="outline"></span>
              </button>
            </span>
            <button nz-button nzType="text" aria-label="View query" (click)="openViewQueryModal(row)">
              <span nz-icon nzType="eye" nzTheme="outline"></span>
            </button>
            <button nz-button nzType="text" aria-label="Delete query" (click)="delete(row)">
              <span nz-icon nzType="delete" nzTheme="outline"></span>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <app-workbench-view-modal
    [isVisible]="isViewModalVisible"
    [isLoading]="isViewModalLoading"
    [row]="selectedRow"
    [queryRecord]="selectedQueryRecord"
    [queryText]="selectedQueryText"
    (close)="closeViewQueryModal()"
  ></app-workbench-view-modal>

  <ng-template #noDataTemplate>No data available</ng-template>
</div>
